import React from 'react'
import ReactDOM from 'react-dom'
import FsLightbox from 'fslightbox-react';

export default function Lightbox () {
    const [toggle, _setToggle] = React.useState(false);
    const [urls, setUrls] = React.useState([]);
    const [slide, setSlide] = React.useState(1);

    const myStateRef = React.useRef(toggle);
    const setToggle = (data) => {
        myStateRef.current = data;
        _setToggle(data);
    };

    React.useEffect(() => {
        const galleryImages = document.querySelectorAll('[data-fslightbox="gallery"]');
        if (galleryImages && galleryImages.length > 0) {
            const tempUrls = []
            galleryImages.forEach((galleryImage) => {
                tempUrls.push(galleryImage.dataset.src)
                galleryImage.addEventListener('click', () => {
                    setSlide(parseInt(galleryImage.dataset.index))
                    setToggle(!myStateRef.current)
                })
            })
            setUrls(tempUrls)
        }
    }, [])

    return <FsLightbox slide={slide} slideDistance={0.3} toggler={toggle} sources={urls}/>
}

document.addEventListener('DOMContentLoaded', function() {
    if (document.getElementsByClassName('fslightbox').length > 0) {
        ReactDOM.render(<Lightbox />, document.getElementsByClassName('fslightbox')[0])
    }
})
